import { Analysis } from 'common-spectrum';
import { parse } from 'spc-parser';
import { spectrumCallback as defaultSpectrumCallback } from "./utils/spectrumCallback.js";
/**
 * Creates a new Analysis from an SPC buffer.
 * @param buffer - SPC file buffer.
 * @param options - Options for the analysis.
 * @returns New Analysis element with the given data.
 */
export function fromSPC(buffer, options = {}) {
    const { spectrumCallback = defaultSpectrumCallback, ...rest } = options;
    const analysis = new Analysis({ ...rest, spectrumCallback });
    const result = parse(buffer);
    const resultMeta = { ...result.meta };
    delete resultMeta.parameters;
    for (const spectrum of result.spectra) {
        const { parameters: _spectrumParameters, ...spectrumMeta } = spectrum.meta ?? {};
        analysis.pushSpectrum(spectrum.variables, {
            dataType: 'IR SPECTRUM',
            title: '',
            meta: { ...resultMeta, ...spectrumMeta },
        });
    }
    return analysis;
}
//# sourceMappingURL=fromSPC.js.map